export const CONTACT = {
  phoneDisplay: '(646) 399-8746',
  phoneRaw: '6463998746',
  sms: 'sms:+16463998746',
  whatsapp: 'https://wa.me/16463998746',
  email: 'leal11sports@gmail.com',
  location: 'Middle Village, NY 11379',
  field: 'Juniper Valley Park, Middle Village, NY',
  logo: 'https://cdn.magicpatterns.com/uploads/qwuwFrXqhm6CeVZezqbHcp/Logo.webp',
  coachPortrait: 'https://cdn.magicpatterns.com/uploads/ehpsHYGuL6Bi8u48NivUyh/about.webp',
  hero: 'https://cdn.magicpatterns.com/uploads/xcJocyMCvaY79pUAovjZmb/Hero.webp',
  instagram: 'https://www.instagram.com/leal11sports/',
  facebook: 'https://www.facebook.com/share/1ErMdZnsF7/?mibextid=wwXIfr',
};

export const PROMO = '20% OFF before September 5th, 2025';

export type Plan = {
  name: string;
  /** Optional original list price. When set, it's shown struck through with a discount badge. */
  regularPrice?: number;
  /** Price actually charged — must match the Stripe link amount. */
  price: number;
  cap: string;
  featured: boolean;
  tagline: string;
  features: string[];
  /** Checkout / signup destination. Replace with your payment or booking link. */
  ctaHref: string;
};

export const PLANS: Plan[] = [
  {
    name: 'STANDARD',
    price: 145,
    cap: '10–15 players per group',
    featured: false,
    tagline: 'Build the fundamentals',
    ctaHref: 'https://buy.stripe.com/cNi3co3yKeOV1tU4M6bQY00',
    features: [
      'Two group sessions per week',
      'Performance test',
    ],
  },
  {
    name: 'PREMIUM',
    price: 225,
    cap: '8–10 players per group',
    featured: true,
    tagline: 'Most chosen by parents',
    ctaHref: 'https://buy.stripe.com/9B628k7P05ela0qceybQY0a',
    features: [
      'Two group sessions per week',
      'Multi-sport challenge assessment',
      'Performance test',
    ],
  },
  {
    name: 'GOLD',
    price: 265,
    cap: '4–6 players per group',
    featured: false,
    tagline: 'Elite development track',
    ctaHref: 'https://buy.stripe.com/fZu4gs8T48qxa0qa6qbQY02',
    features: [
      'Two group sessions per week',
      'One-on-one session per month',
      'Monitoring of each session',
      'Web access membership for audiovisual support resources',
      'Multi-sport challenge assessment',
      'Training check-up session',
      'Performance test',
    ],
  },
];

export const SPECIALIZED_PACKS = [
  {
    name: '4 Sessions',
    price: 140,
    featured: false,
    badge: '',
    ctaHref: 'https://buy.stripe.com/3cIcMY0myeOV0pQ0vQbQY06',
    features: ['Goalkeeper or 1-on-1 training', 'Elite technique mastery', 'Ages 7-25'],
  },
  {
    name: '8 Sessions',
    price: 260,
    featured: false,
    badge: '',
    ctaHref: 'https://buy.stripe.com/9B628kc5g0Y55Ka6UebQY07',
    features: ['Goalkeeper or 1-on-1 training', 'Elite technique mastery', 'Ages 7-25'],
  },
  {
    name: '12 Sessions',
    price: 365,
    featured: true,
    badge: 'Best Value',
    ctaHref: 'https://buy.stripe.com/8x2fZab1c5elegG1zUbQY08',
    features: ['Goalkeeper or 1-on-1 training', 'Elite technique mastery', 'Ages 7-25'],
  },
];

export const CREDENTIALS = [
  { label: 'FIFA Registered Coach', detail: 'Licensed & certified' },
  { label: 'International Coach', detail: 'Licensed in Venezuela & USA' },
  { label: 'National University League', detail: 'Former soccer player' },
];

export const FAQS = [
  {
    question: 'What equipment does my child need?',
    answer:
      'Players need soccer cleats, shin guards, athletic socks, comfortable training clothes, and a water bottle. A size-appropriate ball is recommended but not required — we provide balls for every session. Goalkeepers should bring gloves.',
  },
  {
    question: 'Where do the training sessions take place?',
    answer:
      'All sessions are held at Juniper Valley Park in Middle Village, NY 11379. We meet on the turf fields near the main entrance. You receive the exact meeting point and session schedule by text after registration.',
  },
  {
    question: 'What happens if it rains?',
    answer:
      'Light rain is part of the game — sessions continue as scheduled. For heavy rain, thunderstorms, or unsafe field conditions, we text all parents at least 90 minutes before start time and the session is rescheduled or credited to the following week. No session is ever lost.',
  },
  {
    question: 'What ages and levels do you train?',
    answer:
      'We train kids and teens from 5 to 17, grouped by age and ability. Beginners learn technique, coordination, and confidence. Advanced players work on speed of play, tactical decisions, and tryout preparation.',
  },
  {
    question: 'How does the 20% discount work?',
    answer:
      'Register before September 5th, 2025 and your monthly membership is 20% off, locked in for your first three months. Just claim it through the form below or text us directly.',
  },
];

export const GALLERY_PHOTOS = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/4mBupoQkQ1Znd8ncHhXGPK/picture1.webp',
    alt: 'Coach Leonard running a ball-control drill with a young keeper at Juniper Valley Park',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kTQQ1hacNSYTia84pNYmX9/Picture2.webp',
    alt: 'Goalkeeper stretching for a high save during a shot-stopping drill',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/b1i2iTaibENvoqhGB6P2Xz/Picture3.webp',
    alt: 'Coach Leal setting up a cone circuit with a player waiting to start',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8rcn48J6AHjtGd4sU59yK3/Picture4.webp',
    alt: 'Young goalkeeper diving across the goal to reach the ball',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pGnafzRMvLLWj3zkbCSwMf/Picture5.webp',
    alt: 'Young keeper in full kit kneeling on the pitch after a session',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9GbpwBYRLwPUYbqJzzEYrp/picture6.webp',
    alt: 'Player jumping through hurdles during an agility circuit with Coach Leal',
  },
];

export type Reel = {
  /** Paste a direct .mp4 URL here (or leave empty to keep the placeholder). */
  videoUrl: string;
  /** Poster frame shown before the video plays. */
  poster: string;
  alt: string;
  title: string;
  duration: string;
};

export const GALLERY_REELS: Reel[] = [
  {
    videoUrl: 'https://cdn.magicpatterns.com/uploads/3pUZXUyaVXLu44iQYD9DSU/v3.mp4',
    poster: 'https://cdn.magicpatterns.com/uploads/8rcn48J6AHjtGd4sU59yK3/Picture4.webp',
    alt: 'Reel: diving save and finishing session',
    title: 'Finishing session',
    duration: '1:04',
  },
  {
    videoUrl: 'https://cdn.magicpatterns.com/uploads/kwVJDHqbMibYg5Ap4UQePc/v2.mp4',
    poster: 'https://cdn.magicpatterns.com/uploads/9GbpwBYRLwPUYbqJzzEYrp/picture6.webp',
    alt: 'Reel: speed and agility hurdle work',
    title: 'Speed & agility work',
    duration: '0:52',
  },
  {
    videoUrl: 'https://cdn.magicpatterns.com/uploads/vZthd45ioQ6MHwV2MRC7X7/v1.mp4',
    poster: 'https://cdn.magicpatterns.com/uploads/kTQQ1hacNSYTia84pNYmX9/Picture2.webp',
    alt: 'Reel: shot-stopping and ball mastery drill',
    title: 'Ball mastery drill',
    duration: '0:38',
  },
];

export const SOCIAL_PROOF = [
  { plan: 'Gold Membership', area: 'Middle Village' },
  { plan: 'Premium Membership', area: 'Maspeth' },
  { plan: 'Standard Membership', area: 'Ridgewood' },
  { plan: 'Premium Membership', area: 'Forest Hills' },
  { plan: 'Gold Membership', area: 'Rego Park' },
];
